export const environment = {
  //Development environment
  production: false,  
  apiUrl: ''  // Ahora la configuración está en assets/config.json,
};